import { render, staticRenderFns } from "./mkqy02GameVue.vue?vue&type=template&id=7fa46e06&scoped=true"
import script from "./mkqy02GameVue.vue?vue&type=script&lang=js"
export * from "./mkqy02GameVue.vue?vue&type=script&lang=js"
import style0 from "./mkqy02GameVue.vue?vue&type=style&index=0&id=7fa46e06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa46e06",
  null
  
)

export default component.exports